<template>
    <div>
        <mobile-template>
            <div v-if="loadingConnect" class="w-full h-[calc(100vh-64px)] flex flex-col items-center justify-center bg-gray-50 px-6 text-center">
                
                <div class="w-64 h-64 mb-8 animate-float">
                    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                        <rect x="40" y="150" width="120" height="6" rx="3" fill="#374151" />
                        <rect x="60" y="80" width="80" height="55" rx="4" fill="#1F2937" />
                        <rect x="65" y="85" width="70" height="40" rx="2" fill="#ef4444" fill-opacity="0.1" />
                        <path d="M90 135 L110 135 L115 150 L85 150 Z" fill="#374151" />
                        <path d="M145 150 L145 120 Q145 110 135 110" stroke="#ef4444" stroke-width="4" fill="none" />
                        <circle cx="132" cy="110" r="8" fill="#ef4444" />
                        <rect x="50" y="135" width="15" height="15" rx="2" fill="#374151" />
                        <path d="M57 135 Q50 115 45 120 M57 135 Q65 115 70 120" stroke="#10b981" stroke-width="3" fill="none" />
                        <rect x="70" y="92" width="30" height="4" rx="2" fill="#ef4444" />
                        <rect x="70" y="102" width="50" height="4" rx="2" fill="#4b5563" />
                        <rect x="70" y="112" width="20" height="4" rx="2" fill="#ef4444" />
                    </svg>
                </div>

                <div class="space-y-4">
                    <h2 class="text-2xl font-bold text-gray-800 tracking-tight">
                        Chargement de votre espace
                    </h2>
                    <p class="text-gray-500 font-medium">Préparation de vos outils de travail...</p>
                    
                    <div class="mx-auto w-48 h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div class="progress-loader bg-red-600 h-full rounded-full"></div>
                    </div>
                </div>
            </div>
            
            <div v-show="!loadingConnect">
                <iframe 
                    ref="connectIframe"
                    :src="urlConnect" 
                    @load="onIframeLoad"
                    frameborder="0" 
                    class="w-full h-[calc(100vh-64px)]"
                ></iframe>
            </div>
        </mobile-template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loadingConnect: true, // On commence en chargement
            urlConnect: null,
        }
    },

    methods: {
        async connect() {
            this.loadingConnect = true
            try {
                let response = await this.$request.post('/mobile/generate-token-tech-mobile')
                
                if (!response.success) {
                    this.$toast.error(response.message || 'Code de connexion invalide')
                    this.loadingConnect = false
                    return
                }

                // On définit l'URL, mais loadingConnect reste à TRUE
                const DESKTOP_BASE = window.location.hostname === 'localhost'
                    ? 'http://localhost:8144'
                    : 'https://app.termoflow.fr'

                this.urlConnect = DESKTOP_BASE + '/app/auth?token=' + response.token + '&session=1'
            } catch (error) {
                this.loadingConnect = false
                this.$toast.error("Erreur de connexion")
            }
        },

        onIframeLoad() {
            try {
                const iframe = this.$refs.connectIframe;
                if (!iframe) return;

                // On vérifie le chemin actuel de l'iframe
                const currentPath = iframe.contentWindow.location.pathname;

                // Si le chemin contient /app, on cache enfin le loader
                if (currentPath.includes('/app')) {
                    this.loadingConnect = false;
                }
            } catch (e) {
                // Si on a une erreur de sécurité (CORS), on ne peut pas lire le chemin.
                // Dans ce cas, on libère le loader au premier chargement réussi par défaut.
                console.warn("Accès cross-origin refusé : impossible de vérifier l'URL exacte.");
                this.loadingConnect = false;
            }
        }
    },
    mounted () {
        this.connect();
    },
};
</script>

<style scoped>
/* Animation de flottaison pour le bureau */
.animate-float {
    animation: float 4s ease-in-out infinite;
}

@keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-15px); }
}

/* Animation de la barre de progression "indéterminée" */
.progress-loader {
    width: 40%;
    animation: loading-bar 2s infinite ease-in-out;
}

@keyframes loading-bar {
    0% {
        transform: translateX(-100%);
        width: 20%;
    }
    50% {
        width: 60%;
    }
    100% {
        transform: translateX(250%);
        width: 20%;
    }
}

/* Optionnel : un petit effet néon sur le texte */
h2 {
    text-shadow: 0 0 1px rgba(239, 68, 68, 0.1);
}
</style>